module.exports = __webpack_public_path__ + "static/media/xlsx.f9d6ac4f.png";